export default __webpack_public_path__ + "static/media/chariot.7d2b07b1.png";